var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg998220(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D5CD"
    },
    d: "M80.523,244.13c-2.59,0-5.119-1.299-6.585-3.66l-16.31-26.276H35.097 c-4.276,0-7.742-3.465-7.742-7.742c0-4.277,3.466-7.742,7.742-7.742h26.839c2.678,0,5.165,1.384,6.578,3.659l18.581,29.935 c2.255,3.634,1.139,8.406-2.495,10.66C83.328,243.754,81.917,244.13,80.523,244.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8E5FC"
    },
    d: "M345.569,149.77l-0.867-6.565c-1.383-12.191-11.695-21.399-23.969-21.399H116.945 c-12.274,0-22.586,9.208-23.969,21.399l-0.867,6.565l-11.592,87.649v11.128h276.645v-11.128L345.569,149.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8DCF4"
    },
    d: "M137.528,149.77l0.867-6.565c1.383-12.191,11.695-21.399,23.969-21.399h-45.419 c-12.274,0-22.586,9.208-23.969,21.399l-0.867,6.565l-11.592,87.649v11.128h45.419v-11.128L137.528,149.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74767F"
    },
    d: "M344.702,143.205l0.867,6.565H92.108l0.867-6.565c1.383-12.191,11.695-21.399,23.969-21.399h203.788 C333.006,121.806,343.319,131.014,344.702,143.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636570"
    },
    d: "M137.528,149.77L137.528,149.77l0.867-6.565c1.383-12.191,11.695-21.399,23.969-21.399h-45.419 c-2.301,0-4.534,0.323-6.651,0.93c-1.412,0.405-2.773,0.934-4.068,1.577c-2.592,1.287-4.925,3.028-6.89,5.124 c-1.965,2.098-3.563,4.551-4.685,7.265c-0.841,2.035-1.414,4.216-1.674,6.501l-0.867,6.565h45.419V149.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D5CD"
    },
    d: "M168.258,342.71v32.588c0,5.946-4.821,10.766-10.766,10.766h-36.717V342.71H168.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74767F"
    },
    d: "M136.258,386.065v8.712c0,7.732-6.266,13.997-13.997,13.997H81.094 c-7.732,0-13.997-6.266-13.997-13.997V342.71h10.849h58.312V386.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656872"
    },
    d: "M101.677,394.777V342.71H77.946H67.097v52.067c0,7.732,6.266,13.997,13.997,13.997h34.581 C107.943,408.774,101.677,402.508,101.677,394.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE4242"
    },
    d: "M45.419,207.484v3.778c0,7.608-6.163,13.77-13.77,13.77H13.77c-7.608,0-13.77-6.163-13.77-13.77 v-7.556c0-7.608,6.163-13.77,13.77-13.77h17.879c7.608,0,13.77,6.163,13.77,13.77V207.484z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADD6F2"
    },
    d: "M111.49,190.452c-2.354,0-4.678-1.068-6.2-3.097c-2.565-3.42-1.871-8.274,1.548-10.839 l16.516-12.387c3.42-2.564,8.274-1.873,10.839,1.548c2.565,3.42,1.871,8.274-1.548,10.839l-16.516,12.387 C114.737,189.948,113.107,190.452,111.49,190.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADD6F2"
    },
    d: "M112.006,220.904c-2.39,0-4.746-1.102-6.262-3.181c-2.519-3.455-1.761-8.297,1.694-10.817 l49.548-36.129c3.457-2.521,8.299-1.761,10.817,1.694c2.519,3.455,1.761,8.297-1.694,10.817l-49.548,36.129 C115.185,220.42,113.589,220.904,112.006,220.904z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC5151"
    },
    d: "M390.204,318.668c-0.65-18.374-2.797-37.13-6.317-56.217c-2.663-14.524-15.391-25.032-30.152-25.032 H83.881c-14.741,0-27.458,10.467-30.142,24.97c-3.499,18.911-5.636,37.677-6.266,56.279c-0.124,3.19-0.186,6.359-0.206,9.538 c-0.114,17.074,13.605,31.019,30.679,31.019h58.312h32h101.161h32h58.312c17.074,0,30.823-13.935,30.689-31.009 C390.4,325.048,390.328,321.858,390.204,318.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF3A3A"
    },
    d: "M106.143,328.206c0.021-3.179,0.083-6.348,0.206-9.538c0.63-18.601,2.766-37.368,6.266-56.279 c2.684-14.503,15.401-24.97,30.142-24.97H83.881c-14.741,0-27.458,10.467-30.142,24.97c-3.499,18.911-5.636,37.677-6.266,56.279 c-0.124,3.19-0.186,6.359-0.206,9.538c-0.114,17.074,13.605,31.019,30.679,31.019h58.312h0.564 C119.748,359.226,106.029,345.28,106.143,328.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE4242"
    },
    d: "M390.204,318.668h-0.01h-86.668H134.152H47.474c-0.124,3.19-0.186,6.359-0.206,9.538 c-0.114,17.074,13.605,31.019,30.679,31.019h58.312h32h101.161h32h58.312c17.074,0,30.823-13.935,30.689-31.009 C390.4,325.048,390.328,321.858,390.204,318.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D12424"
    },
    d: "M106.143,328.206c0.021-3.179,0.083-6.348,0.206-9.538H47.474c-0.124,3.19-0.186,6.359-0.206,9.538 c-0.114,17.074,13.605,31.019,30.679,31.019h58.312h0.564C119.748,359.226,106.029,345.28,106.143,328.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D5CD"
    },
    d: "M134.152,318.668c-0.857-2.725-1.115-5.698-0.65-8.743l3.117-20.335 c1.466-9.528,9.652-16.557,19.293-16.557h125.853c9.641,0,17.827,7.03,19.293,16.557l3.117,20.335 c0.465,3.045,0.206,6.018-0.65,8.743c-2.446,7.855-9.775,13.719-18.643,13.719H152.795 C143.928,332.387,136.599,326.524,134.152,318.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C6C2"
    },
    d: "M297.786,321.233H165.698c-8.867,0-16.196-5.863-18.643-13.719c-0.857-2.725-1.115-5.698-0.65-8.743 l3.117-20.336c0.256-1.667,0.73-3.251,1.369-4.74c-7.341,1.952-13.069,8.078-14.272,15.895l-3.117,20.335 c-0.465,3.045-0.206,6.018,0.65,8.743c2.446,7.855,9.775,13.719,18.643,13.719h132.088c8.131,0,14.956-4.936,17.922-11.811 C301.207,320.999,299.527,321.233,297.786,321.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8E5FC"
    },
    d: "M96,259.097c10.828,0,19.613,8.785,19.613,19.613c0,10.828-8.785,19.613-19.613,19.613 s-19.613-8.785-19.613-19.613C76.387,267.881,85.172,259.097,96,259.097z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C6C1"
    },
    d: "M177.548,309.161h-14.452c-4.276,0-7.742-3.465-7.742-7.742s3.466-7.742,7.742-7.742h14.452 c4.276,0,7.742,3.465,7.742,7.742S181.824,309.161,177.548,309.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C6C1"
    },
    d: "M224,309.161h-21.677c-4.276,0-7.742-3.465-7.742-7.742s3.466-7.742,7.742-7.742H224 c4.276,0,7.742,3.465,7.742,7.742S228.276,309.161,224,309.161z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5FED65"
    },
    d: "M374.71,103.226c-75.819,0-137.29,61.471-137.29,137.29s61.471,137.29,137.29,137.29 S512,316.335,512,240.516S450.529,103.226,374.71,103.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2BD62B"
    },
    d: "M318.968,240.516c0-61.622,40.605-113.764,96.516-131.133c-12.882-4.001-26.577-6.157-40.774-6.157 c-75.819,0-137.29,61.471-137.29,137.29s61.471,137.29,137.29,137.29c14.198,0,27.893-2.156,40.774-6.157 C359.573,354.28,318.968,302.138,318.968,240.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8E5FC"
    },
    d: "M374.71,130.065c60.996,0,110.452,49.455,110.452,110.452S435.706,350.968,374.71,350.968 s-110.452-49.456-110.452-110.452S313.714,130.065,374.71,130.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8DCF4"
    },
    d: "M399.484,345.806c-60.996,0-110.452-49.455-110.452-110.452c0-48.809,31.67-90.222,75.577-104.826 c-56.262,5.103-100.351,52.396-100.351,109.987c0,60.996,49.455,110.452,110.452,110.452c12.187,0,23.911-1.979,34.875-5.626 C406.258,345.643,402.889,345.806,399.484,345.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4CFED"
    },
    d: "M424.258,297.806c-1.981,0-3.963-0.756-5.474-2.267l-49.548-49.548 c-1.452-1.452-2.268-3.421-2.268-5.475v-62.968c0-4.277,3.466-7.742,7.742-7.742c4.276,0,7.742,3.465,7.742,7.742v59.762 l47.281,47.281c3.023,3.025,3.023,7.926,0,10.949C428.221,297.051,426.239,297.806,424.258,297.806z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg998220);
export default __webpack_public_path__ + "static/media/998220.19a1627220d922619b48de8cd002ff2e.svg";
export { ForwardRef as ReactComponent };